/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesQuoteLightDto } from '../../models/sales-quote-light-dto';

export interface QuotesControllerFindLightByTenant$Params {

/**
 * Tenant ID
 */
  tenant: string;

/**
 * Optional status filter (DRAFT, SENT, ACCEPTED, REJECTED)
 */
  status?: string;

/**
 * Optional filter by customer ID
 */
  customer?: string;

/**
 * Optional filter by project manager ID. PM-only users pass their own sub here so the dropdown stays scoped to their quotes.
 */
  projectManagerId?: string;
}

export function quotesControllerFindLightByTenant(http: HttpClient, rootUrl: string, params: QuotesControllerFindLightByTenant$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<Array<SalesQuoteLightDto>>> {
  const rb = new SalesRequestBuilder(rootUrl, quotesControllerFindLightByTenant.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.query('status', params.status, {});
    rb.query('customer', params.customer, {});
    rb.query('projectManagerId', params.projectManagerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<Array<SalesQuoteLightDto>>;
    })
  );
}

quotesControllerFindLightByTenant.PATH = '/o2-sales/quotes/{tenant}/light';
